const two={
	title: '`housing` - це дизайн',
	img:[
		'bi/BDC3E9E1-19B7-4ABA-8B45-41693D938DC8-232-00000044612F7663-1.png',
		'bi/service.jpg',
		'bi/20150511150957.png',
		'bi/img_12394_4.png',
	],
	text: 'Наші товари - проектуються та розробляються у відповідності з Вашими\
		потребами та побажаннями. Багато з них представлені виключно у нас.\
		Ми постійно працюємо над розширенням асортименту та намагаємося\
		вдосконалювати наші пропозиції, враховуючи новітні віяння у сфері\
		садівництва та дизайну приміщень. Декоративні якості нашої продуції\
		дозволять Вам створити прекрасні композиції, вдало доповнять\
		будь-який стильний і сучасний інтер`єр, а також гідно підкреслять рослину в ньому.'
};

export default two;